import {DomainObject} from 'shared/store';
import {observable, action} from 'mobx';

class Expense extends DomainObject {
  @observable id;
  @observable title;
  @observable amount;
  @observable date;
  @observable category;
  @observable note;
  @observable nmbrLineItemId;
  @observable nmbrPresetId;

  @action merge(other) {
    super.merge(other, {
      _numbers: ['amount']
    });
  }
}

export default Expense;
